export type VoicePreset =
  | "none"
  | "woman"
  | "man"
  | "chipmunk"
  | "giant"
  | "robot"
  | "alien"
  | "custom";

export type VoiceShape = {
  pitch: number;
  formant: number;
  monotone: number;
};

export type VoiceSettings = {
  voice: VoicePreset;
  voiceSemitones: number;
  voiceFormant: number;
};

export const MIN_SEMITONES = -12;
export const MAX_SEMITONES = 12;
export const MIN_FORMANT = 0.7;
export const MAX_FORMANT = 1.8;

const SHAPES: Record<Exclude<VoicePreset, "custom">, VoiceShape> = {
  none: { pitch: 1, formant: 1, monotone: 0 },
  woman: { pitch: 1.55, formant: 1.17, monotone: 0 },
  man: { pitch: 0.66, formant: 0.86, monotone: 0 },
  chipmunk: { pitch: 1.9, formant: 1.45, monotone: 0 },
  giant: { pitch: 0.55, formant: 0.78, monotone: 0 },
  robot: { pitch: 1, formant: 1, monotone: 118 },
  alien: { pitch: 1.4, formant: 0.72, monotone: 0 },
};

export const VOICE_ORDER: VoicePreset[] = [
  "none",
  "woman",
  "man",
  "chipmunk",
  "giant",
  "robot",
  "alien",
  "custom",
];

export function isVoicePreset(value: unknown): value is VoicePreset {
  return typeof value === "string" && (VOICE_ORDER as string[]).includes(value);
}

function semitonesToRatio(semitones: number): number {
  return 2 ** (semitones / 12);
}

export function voiceShape(settings: VoiceSettings): VoiceShape {
  if (settings.voice !== "custom") return SHAPES[settings.voice];
  return {
    pitch: semitonesToRatio(settings.voiceSemitones),
    formant: settings.voiceFormant,
    monotone: 0,
  };
}

export function voiceActive(settings: VoiceSettings): boolean {
  const shape = voiceShape(settings);
  return shape.monotone > 0 || shape.pitch !== 1 || shape.formant !== 1;
}
